import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, ButtonLoader, MessageService } from '../../../../../core';
import { Lead } from '../../lead';
import { LeadCrudHttpService } from '../../services';
import { LeadContatoFormComponent } from '../form';
import { LeadContato } from '../lead-contato';
import { LeadContatoHttpService } from '../services';
import { PessoaContatoTipo } from '../../../../pessoa/contato';


@Component({
    selector: 'sgt-lead-contato-form-modal',
    templateUrl: './lead-contato-form-modal.component.html',
    styleUrls: ['./lead-contato-form-modal.component.less']
})
export class LeadContatoFormModalComponent implements OnInit {
    private elModal: any;
    isLoading: boolean;
    editMode: boolean;
    showForm = false;
    private idLead: number;
    private tipoContato: PessoaContatoTipo;
    lead: Lead;
    private idContato: number;

    @Output() afterSave = new EventEmitter<LeadContato>();
    @ViewChild('form') form: LeadContatoFormComponent;

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private leadCrudHttpService: LeadCrudHttpService,
                private leadContatoHttpService: LeadContatoHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.load();
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.clear();
                e.stopPropagation();
            });
    }

    insert(idLead: number, tipoContato: PessoaContatoTipo) {
        this.editMode = false;
        this.idLead = idLead;
        this.tipoContato = tipoContato;
        this.open();
    }

    edit(idLead: number, idContato: number) {
        this.editMode = true;
        this.idLead = idLead;
        this.idContato = idContato;
        this.open();
    }

    private open() {
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    private clear() {
        // this.form.resetForm();
        this.editMode = null;
        this.showForm = false;
        this.idLead = null;
        this.tipoContato = null;
        this.lead = null;
        this.idContato = null;
    }

    /** Carrega o lead do contato */
    private loadLead(): Promise<Lead> {
        return new Promise<Lead>((resolve, reject) => {
            this.leadCrudHttpService.load(this.idLead)
                .pipe(
                    take(1)
                )
                .subscribe(
                    lead => resolve(lead),
                    (error: ApiError) => reject(error)
                );
        });
    }

    /** Carrega o contato */
    private loadContato(): Promise<LeadContato> {
        return new Promise<LeadContato>((resolve, reject) => {
            this.leadContatoHttpService.load(this.idContato)
                .pipe(
                    take(1)
                )
                .subscribe(
                    contato => resolve(contato),
                    (error: ApiError) => reject(error)
                );
        });
    }

    private load() {
        this.isLoading = true;

        Promise.all([
            this.loadLead(),
            this.loadContato()
        ])
        .then((values) => {
            this.isLoading = false;
            this.lead = values[0];

            this.showForm = true;
            setTimeout(() => {
                if (this.editMode) {
                    this.form.edit(values[1]);
                } else {
                    this.form.insert(this.tipoContato?.id ?? null);
                }
            }, 0);
        })
        .catch((error: ApiError) => {
            this.messageService.error(error.message, 'Erro ao carregar o contato', error);
            this.isLoading = false;
            this.close();
        });
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Salva o contato */
    save() {
        if (!this.form.isValid()) {
            this.messageService.info('Para salvar o contato é preciso informar corretamente todos os campos destacados em vermelho', 'Informação');
            return;
        }

        try {
            const btnSave = new ButtonLoader('#btnLeadContatoSave');
            btnSave.loading('Salvando');

            const contato = this.form.entity;
            if (this.editMode) {
                this.leadContatoHttpService.update(contato)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        response => {
                            this.messageService.success('', `Contato ${contato.nome} atualizado com sucesso`);
                            btnSave.reset();
                            this.afterSave.emit(response);
                            this.close();
                        },
                        (error: ApiError) => {
                            this.messageService.error(error.message, `Erro ao atualizar o contato ${contato.nome}`, error);
                            btnSave.reset();
                        }
                    );
            }  else {
                this.leadContatoHttpService.insert(this.idLead, contato)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        response => {
                            this.messageService.success('', `Contato ${contato.nome} adicionando com sucesso`);
                            btnSave.reset();
                            this.afterSave.emit(response);
                            this.close();
                        },
                        (error: ApiError) => {
                            this.messageService.error(error.message, `Erro ao adicionar o contato ${contato.nome}`, error);
                            btnSave.reset();
                        }
                    );
            }
        } catch (error) {
            this.messageService.error('Ocorreu um erro ao salvar o contato. Tente novamente', 'Erro', error);
        }
    }
}
